import { useState } from "react";
import { useTranslation } from "react-i18next";

const TAB_IDS = ["tab1", "tab2", "tab3", "tab4", "tab5"] as const;

function ContentBlock({ text }: { text: string }) {
  return (
    <p className="mb-3 text-black last:mb-0 jandi-guidance-content" style={{ whiteSpace: "pre-line" }}>
      {text}
    </p>
  );
}

function SectionTitle({ text }: { text: string }) {
  return (
    <p className="mt-4 mb-1 font-semibold text-gray-800 jandi-guidance-title first:mt-0" style={{ fontSize: '15px' }}>
      {text}
    </p>
  );
}

export default function ClientGuidanceTabs() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<(typeof TAB_IDS)[number]>("tab1");

  return (
    <div className="w-full max-w-6xl mx-auto mt-6 text-gray-700 px-2 jandi-guidance-page">
      {/* --- Tab Buttons --- */}
      <div className="flex flex-col gap-2 mb-4">
        <div className="bg-gray-100 rounded-xl p-1 flex flex-nowrap gap-1">
          {TAB_IDS.map((tabId) => (
            <button
              key={tabId}
              onClick={() => setActiveTab(tabId)}
              className={`jandi-guidance-tabs px-2 py-3 rounded-lg transition-all duration-200 font-medium text-left flex-1 min-w-0 max-w-[180px] ${
                activeTab === tabId
                  ? "bg-white shadow text-[#4285F4] border-b-2 border-[#4285F4]"
                  : "text-gray-600 hover:text-[#4285F4] border-b-2 border-transparent"
              }`}
            >
              {t(`clientGuidance_${tabId}_title`)}
            </button>
          ))}
        </div>
      </div>

      {/* --- Tab Content --- */}
      <div className="bg-white shadow-sm rounded-2xl p-6 leading-relaxed border jandi-guidance-content">
        {activeTab === "tab1" && (
          <div className="space-y-1">
            <ContentBlock text={t("clientGuidance_tab1_intro")} />
            <SectionTitle text={t("clientGuidance_tab1_stepsTitle")} />
            <ContentBlock text={t("clientGuidance_tab1_steps")} />
            <SectionTitle text={t("clientGuidance_tab1_multiTitle")} />
            <ContentBlock text={t("clientGuidance_tab1_multi")} />
          </div>
        )}

        {activeTab === "tab2" && (
          <div className="space-y-1">
            <ContentBlock text={t("clientGuidance_tab2_when")} />
            <SectionTitle text={t("clientGuidance_tab2_completeTitle")} />
            <ContentBlock text={t("clientGuidance_tab2_complete")} />
            <SectionTitle text={t("clientGuidance_tab2_platformTitle")} />
            <ContentBlock text={t("clientGuidance_tab2_platform")} />
          </div>
        )}

        {activeTab === "tab3" && (
          <div className="space-y-1">
            <SectionTitle text={t("clientGuidance_tab3_step1Title")} />
            <ContentBlock text={t("clientGuidance_tab3_step1")} />
            <SectionTitle text={t("clientGuidance_tab3_step2Title")} />
            <ContentBlock text={t("clientGuidance_tab3_step2")} />
            <SectionTitle text={t("clientGuidance_tab3_step3Title")} />
            <ContentBlock text={t("clientGuidance_tab3_step3")} />
            <SectionTitle text={t("clientGuidance_tab3_step4Title")} />
            <ContentBlock text={t("clientGuidance_tab3_step4")} />
          </div>
        )}

        {activeTab === "tab4" && (
          <div className="space-y-1">
            <SectionTitle text={t("clientGuidance_tab4_cancel24Title")} />
            <ContentBlock text={t("clientGuidance_tab4_cancel24")} />
            <SectionTitle text={t("clientGuidance_tab4_cancelWithinTitle")} />
            <ContentBlock text={t("clientGuidance_tab4_cancelWithin")} />
            <SectionTitle text={t("clientGuidance_tab4_problemTitle")} />
            <ContentBlock text={t("clientGuidance_tab4_problem")} />
          </div>
        )}

        {activeTab === "tab5" && (
          <div className="space-y-1">
            <SectionTitle text={t("clientGuidance_tab5_smsTitle")} />
            <ContentBlock text={t("clientGuidance_tab5_sms")} />
            <SectionTitle text={t("clientGuidance_tab5_trustTitle")} />
            <ContentBlock text={t("clientGuidance_tab5_trust")} />
            <SectionTitle text={t("clientGuidance_tab5_reviewTitle")} />
            <ContentBlock text={t("clientGuidance_tab5_review")} />
            <SectionTitle text={t("clientGuidance_tab5_behaviorTitle")} />
            <ContentBlock text={t("clientGuidance_tab5_behavior")} />
          </div>
        )}
      </div>
    </div>
  );
}
